/**
 * Logger simples para DevTools
 * Registra eventos no banco sem bloquear a navegação
 */
import store from '@/store';

class SimpleDevToolsLogger {
    constructor(options = {}) {
        this.isOpen = false;
        this.checkInterval = options.interval || 2000; // A cada 2 segundos
        this.threshold = options.threshold || 200;
        this.consecutiveDetections = 0;
        this.maxConsecutiveDetections = 3; // Requer 3 detecções consecutivas

        // Pegar URLs do store
        this.apiUrl = store.getters.api; // baseURL do env.js
        this.normalUrl = store.getters.url; // normalURL do env.js

        console.log('🔍 DevTools Logger inicializado com:', {
            apiUrl: this.apiUrl,
            normalUrl: this.normalUrl
        });

        this.startDetection();
    }

    // Detecta se DevTools está aberto
    detect() {
        const widthThreshold = window.outerWidth - window.innerWidth > this.threshold;
        const heightThreshold = window.outerHeight - window.innerHeight > this.threshold;

        if (widthThreshold || heightThreshold) {
            this.consecutiveDetections++;

            // Só considera detectado após múltiplas detecções consecutivas
            if (this.consecutiveDetections >= this.maxConsecutiveDetections && !this.isOpen) {
                this.isOpen = true;
                this.logEvent('devtools_opened');
            }
        } else {
            this.consecutiveDetections = 0;
            if (this.isOpen) {
                this.isOpen = false;
                this.logEvent('devtools_closed');
            }
        }
    }

    // Inicia a detecção
    startDetection() {
        setInterval(() => {
            this.detect();
        }, this.checkInterval);
    }

    // Registra evento no banco
    async logEvent(eventType) {
        try {
            const logData = {
                event_type: eventType,
                page_url: window.location.href,
                description: eventType === 'devtools_opened'
                    ? 'DevTools foi aberto'
                    : 'DevTools foi fechado',
                additional_data: {
                    screen_width: screen.width,
                    screen_height: screen.height,
                    window_width: window.innerWidth,
                    window_height: window.innerHeight,
                    outer_width: window.outerWidth,
                    outer_height: window.outerHeight,
                    timestamp: new Date().toISOString(),
                    user_agent: navigator.userAgent
                }
            };

            console.log(`🚨 ${eventType.toUpperCase()}:`, logData);

            // Usar axios se disponível, senão fetch
            if (typeof axios !== 'undefined') {
                await axios.post(`${this.apiUrl}security-log`, logData);
            } else {
                await fetch(`${this.apiUrl}security-log`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(logData)
                });
            }

            console.log('✅ Log registrado no banco');

        } catch (error) {
            console.error('❌ Erro ao registrar log:', error);

            // Log de fallback no console para não perder o evento
            console.warn('📝 FALLBACK LOG:', {
                event: eventType,
                url: window.location.href,
                timestamp: new Date().toISOString()
            });
        }
    }

    // Método para registrar eventos customizados
    logCustomEvent(eventType, description, additionalData = {}) {
        const logData = {
            event_type: eventType,
            page_url: window.location.href,
            description: description,
            additional_data: {
                ...additionalData,
                timestamp: new Date().toISOString(),
                user_agent: navigator.userAgent
            }
        };

        console.log(`📋 EVENTO CUSTOMIZADO: ${eventType}`, logData);

        // Enviar para o backend
        if (typeof axios !== 'undefined') {
            axios.post(`${this.apiUrl}security-log`, logData).catch(console.error);
        } else {
            fetch(`${this.apiUrl}security-log`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(logData)
            }).catch(console.error);
        }
    }

    // Getter para status
    get status() {
        return {
            isOpen: this.isOpen,
            consecutiveDetections: this.consecutiveDetections,
            apiUrl: this.apiUrl,
            normalUrl: this.normalUrl
        };
    }
}

export default SimpleDevToolsLogger;
